import { createFileRoute } from "@tanstack/react-router";
import { ComingSoonPage } from "@/components/layout/page-container.tsx";

export const Route = createFileRoute("/help")({
  component: () => <ComingSoonPage title="使用帮助" />,
});
